$bog_fragile_demo_collide_base1 $mol_view
	sub / <= title \Файл
